import { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ItemCustomization from './ItemCustomization';

const ItemDetailsPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const itemRaw = location.state?.item;

  const item = useMemo(() => itemRaw ? {
    ...itemRaw,
    id: itemRaw.item_id || itemRaw.id,
    name: itemRaw.item_name || itemRaw.name,
    description: itemRaw.description || '',
    price: itemRaw.price || 0,
    image: itemRaw.image_url || itemRaw.image || '',
    item_name: itemRaw.item_name || itemRaw.name,
    item_public_id: itemRaw.item_public_id || itemRaw.item_id || itemRaw.id || Math.random().toString(36).substr(2, 9),
  } : null, [itemRaw]);

  if (!item) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center bg-[#f7f7f5] px-5 text-center">
        <p className="text-[14px] text-neutral-500">This item could not be opened.</p>
        <button
          type="button"
          onClick={() => navigate('/order', { replace: true })}
          className="mt-4 rounded-full border border-neutral-200 bg-white px-4 py-2 text-[13px] font-semibold text-neutral-800"
        >
          Back to menu
        </button>
      </div>
    );
  }

  return <ItemCustomization item={item} onClose={() => navigate(-1)} />;
};

export default ItemDetailsPage;
